import { Button, Typography, ButtonGroup } from "@mui/material";
import { Box } from "@mui/system";
import treeImg from "../assets/treeoverlay.png";
import { Link } from "react-router-dom";
import propertyImg from "../assets/image2.png";
import { useState } from "react";
import EastIconArrow from "../assets/east.svg";
import HoverButton from "./HoverButton";
import { InstaOtherProperties } from "../api/Redirection";
import { GoogleSheetRedirection } from "../api/Redirection";
const NavMenu = ({ onClose }) => {
  const links = ["Tariff", "Gallery", "Contact", "Check Availability"];
  const roomItems = [
    "the tropical suite",
    "the amber suite",
    "the Earthen Suite",
  ];

  const [hoveredIndexR, setHoveredIndexR] = useState(null);

  const handleMouseEnterR = (index) => {
    setHoveredIndexR(index);
  };

  const handleMouseLeaveR = () => {
    setHoveredIndexR(null);
  };

  const [hoveredIndexI, setHoveredIndexI] = useState(null);

  const handleMouseEnterI = (index) => {
    setHoveredIndexI(index);
  };

  const handleMouseLeaveI = () => {
    setHoveredIndexI(null);
  };

  return (
    <Box
      width={"100%"}
      display={"flex"}
      flexDirection={{
        xs: "column",
        sm: "column",
        md: "row",
        lg: "row",
        xl: "row",
      }}
      height={{ md: "100%", xl: "100%", lg: "100%" }}
      // height={"900px"}
      minWidth={"400px"}
      flexWrap={"wrap"}
      sx={{
        borderLeft: { xs: "1px solid #E5D3C3", sm: "1px solid #E5D3C3" },
        marginLeft: { xs: "1rem", sm: "1rem", lg: "0px" },
      }}
    >
      <Box
        display={{ xs: "none", sm: "none", lg: "contents" }}
        borderRight={"1px solid #E5D3C3"}
        flexDirection="column"
        // width={"152px"}
        position={"relative"}
      >
        <Box width={"152px"}>
          <img
            src={treeImg}
            width="122px"
            height="452px"
            alt="tree img"
            style={{ marginTop: "auto", position: "absolute", bottom: 0 }}
          />
        </Box>
      </Box>
      <Box
        flexGrow={{ xs: 4, sm: 4 }}
        border={"1px solid #E5D3C3"}
        display={"flex"}
        justifyContent={"start"}
        alignItems={{ xs: "end", sm: "center" }}
        borderRight={"1px solid #E5D3C3"}
      >
        <Box width={"100%"} display={"flex"} flexDirection={"column"}>
          <Typography
            sx={{
              fontSize: { xs: "12px", sm: "16px" },
              fontWeight: "400",
              marginLeft: 3,
              marginBottom: 1,
              lineHeight: { xs: "14.85px", sm: "19.8px" },
              letterSpacing: "0.05em",
              color: "#4C4C4C",
              fontFamily: "ZapfHumnst BT",
              textTransform: "uppercase",
              marginTop: { xs: "5rem", sm: "5rem" },
            }}
          >
            Rooms
          </Typography>
          <ButtonGroup
            disableElevation
            disableRipple
            fullWidth
            sx={{ display: "flex", justifyContent: "flex-start" }}
            orientation="vertical"
          >
            {roomItems.map((room, index) => (
              <Button
                sx={{
                  height: { xs: "47px", sm: "125px" },
                  padding: { xs: 1, sm: "15px" },
                  border: "1px solid #E5D3C3",
                  borderLeft: { xs: "unset", sm: "unset" },
                  "&:hover": {
                    backgroundColor: "#f4e2d2",
                  },
                  display: "flex",
                  justifyContent: "flex-start",
                  "& img": {
                    width: { xs: "20px", sm: "40px", lg: "61px" },
                  },
                }}
                key={index}
                onMouseEnter={() => handleMouseEnterR(index)}
                onMouseLeave={handleMouseLeaveR}
                onClick={() => {
                  window.scrollTo(0, 0);
                  onClose();
                }}
                LinkComponent={Link}
                to={`/${room.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <img
                  src={EastIconArrow}
                  alt="East"
                  style={{
                    width: { xs: "20px", sm: "40px", lg: "61px" },
                    height: { xs: "20px", sm: "61px", lg: "61px" },
                    transform: hoveredIndexR === index ? "" : "rotate(-50deg)",
                    transition: "transform 0.3s ease",
                  }}
                />
                <Typography
                  sx={{
                    fontSize: { xs: "15px", sm: "40px" },
                    fontWeight: "400",
                    color: "#0F0F0F",
                    lineHeight: { xs: "20.76px", sm: "49.51px" },
                    letterSpacing: "0.05em",
                    fontFamily: "ZapfHumnst BT",
                  }}
                >
                  {room}
                </Typography>
              </Button>
            ))}
          </ButtonGroup>
        </Box>
      </Box>

      <Box
        flexGrow={{ xs: 10, sm: 2 }}
        display={"flex"}
        flexDirection={"column"}
      >
        <Box
          flexGrow={4}
          display={"flex"}
          justifyContent={"end"}
          flexDirection={"column"}
          marginLeft={{ xs: 0, sm: 0, lg: "3rem", xl: "8rem" }}
          marginBottom={{ xs: 1, sm: 3 }}
          marginTop={{ xs: 3, sm: 3 }}
        >
          <Typography
            sx={{
              fontSize: { xs: "12px", sm: "16px" },
              fontWeight: "400",
              marginLeft: 2,
              marginBottom: 1,
              lineHeight: { xs: "14.85px", sm: "19.8px" },
              letterSpacing: "0.05em",
              color: "#4C4C4C",
              fontFamily: "ZapfHumnst BT",
              textTransform: "uppercase",
            }}
          >
            Links
          </Typography>
          <Box display={"flex"} flexDirection={"column"} alignItems={"start"}>
            {links.map((link, index) => (
              <Button
                key={index}
                onMouseEnter={() => handleMouseEnterI(index)}
                onMouseLeave={handleMouseLeaveI}
                onClick={() => {
                  if (link === "Check Availability") {
                    window.open(GoogleSheetRedirection, "_blank");
                    onClose();
                  } else {
                    window.scrollTo(0, 0);
                    onClose();
                  }
                }}
                disableElevation
                LinkComponent={Link}
                disableRipple
                variant="text"
                to={
                  link === "Check Availability"
                    ? "#"
                    : `/${link.toLowerCase().replace(/\s+/g, "-")}`
                }
                startIcon={
                  <img
                    alt="east"
                    src={EastIconArrow}
                    style={{
                      fontSize: "12.92px",
                      transition: "transform 0.3s ease",
                      transform:
                        hoveredIndexI === index ? "" : "rotate(-50deg)",
                    }}
                  />
                }
                sx={{
                  width: "300px",
                  display: "flex",
                  justifyContent: "start",
                  fontSize: { xs: "13px", sm: "22px", md: "20px" },
                  fontWeight: "400",
                  color: "#181818",
                  lineHeight: { xs: "16.09px", sm: "19.8px" },
                  letterSpacing: "0.05em",
                  fontFamily: "ZapfHumnst BT",
                  textTransform: "uppercase",
                  marginLeft: 1,
                  "&:hover": {
                    backgroundColor: "#f9eee2",
                  },
                  "& img": {
                    width: {
                      xs: "20px",
                      sm: "31px",
                      md: "31px",
                      lg: "31px",
                      xl: "31px",
                    },
                  },
                }}
              >
                {link}
              </Button>
            ))}
          </Box>
        </Box>
        <Box
          flexGrow={{ xs: 12, sm: 3 }}
          display={"flex"}
          justifyContent={{
            xs: "start",
            sm: "start",
            md: "center",
            lg: "center",
            xl: "center",
          }}
          alignItems={"center"}
          p={{ xs: 0, sm: 0 }}
          pt={{ xs: 3, sm: 3 }}
          pl={{ xs: 2, sm: 2 }}
          borderTop={"1px solid #E5D3C3"}
          gap={{ xs: 0, sm: 10, md: 10, lg: 6, xl: 6 }}
        >
          <Box display={"flex"} flexDirection={"column"} gap={2}>
            <Typography
              sx={{
                fontSize: { xs: "12px", sm: "16px" },
                fontWeight: "400",
                lineHeight: { xs: "14.85px", sm: "19.8px" },
                letterSpacing: "0.05em",
                color: "#4C4C4C",
                fontFamily: "ZapfHumnst BT",
                textTransform: "uppercase",
              }}
            >
              Other Property
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "20px", sm: "32px" },
                fontWeight: "400",
                color: "#0F0F0F",
                letterSpacing: "5%",
                fontFamily: "ZapfHumnst BT",
                lineHeight: { xs: "24.76px", sm: "39.61px" },
                width: { xs: "150px", sm: "150px" },
                textTransform: "uppercase",
              }}
            >
              container home cliff 362
            </Typography>
            <HoverButton
              onClick={() => {
                window.open(InstaOtherProperties);
                onClose();
              }}
              width={"132px"}
              height={"50px"}
              fillBgColor="#E4CAAE"
              endIcon={
                <img
                  src={EastIconArrow}
                  alt="east"
                  style={{
                    width: "25px",
                    height: "25px",
                    transform: "rotate(-50deg)",
                  }}
                />
              }
              btnText={" Explore"}
            />
          </Box>
          <Box
            width={{ xs: "149px", sm: "215px" }}
            height={{ xs: "128px", sm: "184px" }}
          >
            <img
              src={propertyImg}
              width={"100%"}
              height={"100%"}
              alt="Modern house exterior"
            />
          </Box>
        </Box>
      </Box>
      <Button
        disableElevation
        disableRipple
        sx={{
          position: "absolute",
          color: "#181818",
          right: { xs: 50, sm: 60 },
          top: 30,
          fontSize: { xs: "12px", sm: "18px" },
          fontWeight: "400",
          letterSpacing: "5%",
          fontFamily: "ZapfHumnst BT",
          lineHeight: "36px",
        }}
        onClick={() => {
          window.scrollTo(0, 0);
          onClose();
        }}
      >
        close
      </Button>
    </Box>
  );
};

export default NavMenu;
